var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryNavigationRbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-180 40 40)",
    fill: "#1B1B1B",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 30L23.0765 20.7121C23.622 19.9961 23.622 19.0039 23.0765 18.2879L16 9",
    stroke: "#EBECF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 39.5,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(-180 39.5 39.5)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2017"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-180 40 40)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryNavigationRbutton);
export default __webpack_public_path__ + "static/media/categoryNavigationRbutton.6fbd4ffd541c5a7cd5c337b6351ccaf3.svg";
export { ForwardRef as ReactComponent };